module.exports = __webpack_public_path__ + "static/media/icon-home.b88b68d3.svg";